import {
    clusterUpdateModel,
    clusterUpdateImage
} from "../../../actions/cluster-actions"

import buildItemConnector from "../../common/build-item-connector"

export default buildItemConnector(
    "clusters",
    false,
    clusterUpdateModel,
    clusterUpdateImage
)
